// 积分系统api
import request from '@/utils/request2'

// 获取待报名活动列表接口(参数：进行中/未开展/已结束/已取消)
export function getActivityList (data) {
  return request({
    url: '/api/wx/getActivityList',
    method: 'get',
    params: data
  })
}

// 获取活动详情接口
export function getActivityDetailsInfo (data) {
  return request({
    url: '/api/wx/getActivityDetailsInfo',
    method: 'get',
    params: data
  })
}

// 活动报名接口（包含参赛/工作人员/啦啦队的报名）
export function activityEnroll (data) {
  return request({
    url: '/api/wx/activityEnroll',
    method: 'get',
    params: data
  })
}

// 活动签到接口（需上传附件）
export function activitySignIn (data) {
  return request({
    url: '/api/wx/activitySignIn',
    method: 'post',
    data: data
  })
}

// 获取员工指定年度的积分信息接口
export function getEmpCreditInfo (data) {
  return request({
    url: '/api/wx/getEmpCreditInfo',
    method: 'get',
    params: data
  })
}

// 查看指定年份的积分前20名信息接口
export function getDeptCreditRanking (data) {
  return request({
    url: '/api/wx/getDeptCreditRanking',
    method: 'get',
    params: data
  })
}

// 获取待兑换的商品信息列表接口
export function getCreditProductList (data) {
  return request({
    url: '/api/wx/getCreditProductList',
    method: 'get',
    params: data
  })
}

// 获取某个商品的详细接口
export function getCreditProductDetailInfo (data) {
  return request({
    url: '/api/wx/getCreditProductDetailInfo',
    method: 'get',
    params: data
  })
}

// 员工确定商品兑换接口
export function empExchangeProduct (data) {
  return request({
    url: '/api/wx/empExchangeProduct',
    method: 'post',
    data: data
  })
}

// 获取本人所有兑换记录信息接口
export function getEmpExchangeOrderRecord (data) {
  return request({
    url: '/api/wx/getEmpExchangeOrderRecord',
    method: 'get',
    params: data
  })
}

// 根据guid获取兑换的商品列表接口
export function getExChangeProductByGuid (data) {
  return request({
    url: '/api/wx/getExChangeProductByGuid',
    method: 'get',
    params: data
  })
}

// 管理员扫码确认兑换领取接口
export function checkExChangeProductOutByGuid (data) {
  return request({
    url: '/api/wx/checkExChangeProductOutByGuid',
    method: 'get',
    params: data
  })
}

// 获取某个比赛项目报名的名单
export function getActivityPrjEmpList (data) {
  return request({
    url: '/api/wx/getActivityPrjEmpList',
    method: 'get',
    params: data
  })
}

// 获取签到人员名单接口
export function getActivityPrjEmpSignList (data) {
  return request({
    url: '/api/wx/getActivityPrjEmpSignList',
    method: 'get',
    params: data
  })
}

// 活动取消报名接口
export function activityCancelEnroll (data) {
  return request({
    url: '/api/wx/activityCancelEnroll',
    method: 'get',
    params: data
  })
}
